import React, {} from 'react';
import { useTableInstance } from '../TableContext/index.js';
import { ConfigureColumns } from './ConfigureColumns.js';
export const ConnectedConfigureColumns = (props) => {
    const { columns, disableColumnOrder, defaultColumn, state: { columnOrder }, setColumnOrder, setHiddenColumns, dispatch, originalColumns } = useTableInstance();
    const { setMyRowSize } = props;
    return (React.createElement(ConfigureColumns, { columns: columns, columnOrder: columnOrder, disableColumnOrder: disableColumnOrder, setColumnOrder: setColumnOrder, setHiddenColumns: setHiddenColumns, setMyRowSize: setMyRowSize, resetResize: () => {
            const columnWidths = {};
            columns.map((column) => {
                const original = originalColumns.find((c) => c.accessor === column.id);
                /* istanbul ignore next */
                const width = original?.width ?? defaultColumn?.width ?? 150;
                columnWidths[column.id] = width;
            });
            dispatch({
                type: 'resetColumnWidths',
                columnWidths: columnWidths
            });
        } }));
};
//# sourceMappingURL=ConnectedConfigureColumns.js.map